import { createTheme } from '@mui/material/styles';

export const colors = {
   primary: '#BFA2DB', // Violet glycine
   secondary: '#E6DAF0', // Lavande pâle
   accent: '#C8E6C9', // Vert doux
   background: '#FAF9F6', // Blanc cassé
   text: '#333333', // Texte principal
   muted: '#666666', // Texte secondaire
};

export const theme = createTheme({
   palette: {
      mode: 'light',
      primary: {
         main: '#BFA2DB', // lavande douce
         contrastText: '#ffffff',
      },
      secondary: {
         main: '#A98DC6', // lavande plus foncée
      },
      background: {
         default: '#FAF9F6', // fond clair doux
         paper: '#ffffff',
      },
      text: {
         primary: '#333333',
         secondary: '#666666',
      },
   },
   typography: {
      fontFamily: `"Helvetica Neue", "Arial", sans-serif`,
      button: {
         fontWeight: 600,
         textTransform: 'none',
      },
   },
});
